// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  mock: false,
  is_private_app: false,
  deploy_on_k8s: false,
  public_api_endpoint: 'http://10.207.252.82:8688/scontract-web-api/api',
  private_api_endpoint: 'http://10.207.252.82:8688/scontract-web-api/api',
  // public_api_endpoint: 'http://localhost:8091/api',
  // private_api_endpoint: 'http://localhost:8091/api',
  genimage_api_base_url: 'http://10.207.252.81:8625/scontract-web-api/api',
  is_use_env_file: true,
  pdf_view_full_download: false,
  public_api_endpoint_digital: 'http://10.60.156.247:8041/api',
  notify_service: 'http://10.60.156.247:8088/scontract-notify',
  firebase: {
    apiKey: 'AIzaSyBD9pEGTgKRKy7ktuX9oM_BHPTCTHo9iMw',
    authDomain: 'vcontract-release.firebaseapp.com',
    projectId: 'vcontract-release',
    // storageBucket: 'vcontract-release.appspot.com',
    storageBucket: 'vcontract-release.firebasestorage.app',
    messagingSenderId: '883167843461',
    appId: '1:883167843461:web:9aea288a1f53b72b0585ec',
    measurementId: 'G-JYVN1FFJ1Z'
  },
  sme_portal_url: 'http://10.207.252.76:8777',
  sme_client_id: 'vcontract',
  vcontract_url: 'http://sso-scontract.viettel.vn:8213',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
